<template>
  <product-variant-selection
    v-if="product"
    v-model="attributeSelection"
    v-model:form-ref="attributeSelectionFormRef"
    as-form
    :attribute-selection-labels
    :error
    :get-attr-option-available
    :get-attr-option-notify-me
    :inventory
    :is-coming-soon
    :pending
    :product
    :reviews-data
    :selected-variant
    :show-single-attributes="$feature.showSingleAttributeOnPdp"
    @select-color="selectColor"
    @select-size="selectSize"
  >
    <template #sizing-info>
      <div v-if="showModelMeasurements || showSizeChart" class="mt-4 rounded-lg bg-brand-3 px-2 py-3 space-y-3 lg:bg-white">
        <div v-if="showMeasurementsSection" class="flex items-center">
          <vf-icon class="mr-3 shrink-0" name="size" size="lg" />
          <span>
            <p v-if="sizeAdvice" class="body-2 c-grey-40">
              {{ sizeAdvice }}
            </p>
            <pdp-section-model-measurements v-if="showModelMeasurements" />
          </span>
        </div>
        <hr v-if="showMeasurementsSection" class="b-brand-7">
        <div class="flex items-center">
          <vf-icon v-if="!showMeasurementsSection" class="mr-3 shrink-0" name="size" size="md" />
          <span class="flex items-center gap-4 text-xs underlined between">
            <pdp-section-size-chart v-if="showSizeChart" class="mb-0.5 text-sm o:items-start" style="line-height: 23px" @open="openSizeChart" />
            <pdp-section-fit-finder v-if="showFitFinder" />
          </span>
        </div>
      </div>
    </template>
  </product-variant-selection>
  <dialog-size-chart
    :class-content="brandClasses.sizeChartDialog"
    :size="$viewport.lg ? 'md' : 'lg'"
    :style-content="$viewport.lg ? 'min-width: 51rem' : ''"
  />
</template>

<script lang="ts" setup>
const {
  attributeSelection,
  attributeSelectionFormRef,
  attributeSelectionLabels,
  error,
  inventory,
  isComingSoon,
  getAttrOptionAvailable,
  getAttrOptionNotifyMe,
  pending,
  product,
  reviewsData,
  selectColor,
  selectSize,
  selectedVariant,
  showFitFinder,
  showModelMeasurements,
  showSizeChart
} = usePdp()
const { $gtm, $t } = useNuxtApp()
const { brandClasses, sizeChart } = useAppConfig().pages.pdp
const DialogSizeChart = createDialog('size-chart', sizeChart?.dialogOptions)

const sizeAdvice = computed(() => {
  const key = product.value?.sizeAdvice
  return key ? $t.sizeAdvice[key] : ''
})

const showMeasurementsSection = computed(() => sizeAdvice.value || showModelMeasurements.value)

const openSizeChart = () => {
  $gtm.push('pdpPage.onOpenSizeGuide')
  if (product.value?.sizeChart) {
    DialogSizeChart.open({
      productType: product.value.sizeChart,
      id: product.value.id,
      sizeAdvice: product.value.sizeAdvice
    })
  }
}
</script>
